<template>
    <div class="footer-newsletter text-center">
        <h3>Follow us for further information</h3>
        <div class="footer-newsletter-form">
            <form id="subscribe-form" method="post" @submit.prevent="subscribeFormSubmit">
                <div class="form-row mb-3">
                    <div class="form-group m-0">
                        <input type="email" class="form-control" v-model.trim="$v.formData.email.$model" placeholder="Enter Your Email">                        
                    </div>
                    <div class="form-group m-0">
                        <button type="submit" class="theme-button">Subscribe</button>
                    </div>                    
                </div>
                <span class="alert-danger alert" v-if="!formStatus && $v.formData.email.$error && !$v.formData.email.required">Please Enter your email!</span>
                <span class="alert-danger alert" v-if="!formStatus && $v.formData.email.$error && !$v.formData.email.email">Invalid Email Address!</span>
                <div class="resMssg text-center" v-html="formResponse"></div>
            </form>
            
        </div>
    </div>
</template>

<script>
import { required, email } from 'vuelidate/lib/validators'

export default {
    data() {
        return {
            formData: {
                email: ''
            },
            formResponse: '',
            formStatus: true
        }
    },
    validations: {
        formData: {
            email: {required,email},
        }
    },
    methods: {
        subscribeFormSubmit(){
            this.formStatus = false
            this.$v.$touch()
            if(!this.$v.$invalid){
                document.querySelector('.resMssg').style.display = 'block'
                this.formResponse = ''
                this.$http.post(`/subscriber`, this.formData )
                .then(res=>{
                    if(typeof res !== 'undefined' && res.status === 200){
                        if(res.data.status === true){                            
                            this.formResponse =`<span class="alert alert-success">${res.data.message}</span>`    
                            this.formData.email = ''
                            this.formStatus = true
                        }                
                        else
                            this.formResponse =`<span class="alert alert-danger">${res.data.error.email}</span>`
                    }
                    
                }).catch(err => {
                    console.log('err', err);
                    this.formResponse =`<span class="alert alert-danger">Something Went Wrong!</span>`
                })

                this.togellingResponse();
            }
        },
        togellingResponse(){
            setTimeout(()=>{
                document.querySelector('.resMssg').style.display = 'none'
            }, 5000)
        }
    }
    
}
</script>